// extracted by mini-css-extract-plugin
export var arrow = "Carousel-module--arrow--a9966";
export var autoWidth = "Carousel-module--autoWidth--5c602";
export var container = "Carousel-module--container--2d10a";
export var dot = "Carousel-module--dot--d0e45";
export var dots = "Carousel-module--dots--1d7bd";
export var editing = "Carousel-module--editing--404d7";
export var nav = "Carousel-module--nav--02820";
export var root = "Carousel-module--root--068c8";
export var viewport = "Carousel-module--viewport--70191";